import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthApiService } from './auth-api.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthApiService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const contentType = request.headers.get('Content-Type');
    
    return from(this.authService.getCurrentUser()).pipe(
      switchMap(currentUser => {
        if (currentUser && contentType!=='application/octet-stream') {
          const authReq = request.clone({
            headers: request.headers
            .set('Authorization', currentUser.jwtId)
            .set('Content-Type', 'application/json')
          });
          return next.handle(authReq);
        }
        return next.handle(request);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return from(this.authService.getCurrentUser()).pipe(switchMap(user => {
            if (user && contentType!=='application/octet-stream') {
              const authReq = request.clone({
                headers: request.headers
                .set('Authorization', user.jwtId)
                .set('Content-Type', 'application/json')
              });
              return next.handle(authReq);
            }else if (user && contentType==='application/octet-stream') {
              return next.handle(request);
            }else {
              this.authService.signOut();
              return throwError(error);
            }
          }));
        }
        return throwError(error);
      })
    );
  }
}